const ALIAS = {
  air: ['air'],
  o2: ['o2', 'oxygen'],
  he: ['he', 'helium']
}

export function matchComponent (name) {
  if (typeof name !== 'string') return null
  const key = name.trim().toLowerCase()
  if (!key) return null
  for (const component of Object.keys(ALIAS)) {
    if (ALIAS[component].indexOf(key) !== -1) return component
  }
  return null
}



// WEBPACK FOOTER //
// ./src/components/dashboard/stations/station/Pricing/componentAlias.js